import Button from "@pathwright/ui/src/components/button/Button"
import SubmitButton from "@pathwright/ui/src/components/button/SubmitButton"
import RichTextInput from "@pathwright/ui/src/components/form/form-richtext/RichTextInput"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Tooltip from "@pathwright/ui/src/components/tooltip/Tooltip"
import { getStepVerbIcon } from "@pathwright/web/src/modules/path/utils"
import {
  ConnectForm,
  SelectInput,
  TextInput,
  validate
} from "lib/core/components/forms"
import { STEP_TYPES } from "path/constants"
import "./PathStepForm.css"

let fieldsData = {
  verb: {
    placeholder: "Select action...",
    options: STEP_TYPES,
    labelKey: "verb",
    valueKey: "type",
    hideStatus: true,
    minimal: true,
    inline: true,
    valueRenderer({ verb }) {
      return (
        <span className="PathStep__FormVerb">
          <Pathicon icon={getStepVerbIcon(verb)} />
          {verb}
        </span>
      )
    },
    optionRenderer({ verb, examples }) {
      return (
        <div className="PathStep__FormOptions">
          <Pathicon icon={getStepVerbIcon(verb)} />
          <strong>{verb}:</strong>
          <span>{examples}</span>
        </div>
      )
    }
  },
  name: {
    placeholder: "Enter a step name...",
    hideStatus: true,
    minimal: true,
    inline: true
  },
  description: {
    placeholder: "Add a personal introduction (Optional)",
    minHeight: 25,
    optional: true,
    minimal: true,
    theme: "bubble",
    createCustomToolbar: () => ["link"],
    validations: [validate.maxLength(140)]
  }
}

let PathStepForm = function (props) {
  let actionLabel, handleSubmit, isValid, onCancel, selection, standalone
  ;({
    standalone,
    selection,
    fieldsData,
    handleSubmit,
    actionLabel,
    onCancel,
    isValid
  } = props)

  const { t } = useTranslate()

  let placholder = __guard__(
    _.find(
      STEP_TYPES,
      (stepType) =>
        stepType.type === (fieldsData.verb.value && fieldsData.verb.value.type)
    ),
    (x) => t(`path.step_types.${fieldsData.verb.value.type}.prompt`)
  )
  if (placholder == null) {
    placholder = t("path.step_types.default.prompt")
  }

  const disableVerbInput =
    selection.content && selection.content.type !== "blocks"

  return (
    <form className="PathStep__Form" autoComplete="off" onSubmit={handleSubmit}>
      <div className="PathStep__FormInputs">
        <span className="PathStep__FormPrefix">Learner should</span>
        <Tooltip
          title={
            disableVerbInput
              ? "Cannot update step verb. Step is using legacy content."
              : null
          }
        >
          <SelectInput
            {...Object.assign({}, fieldsData.verb, {
              disabled: disableVerbInput
            })}
          />
        </Tooltip>
        :
        <TextInput
          {...Object.assign({}, fieldsData.name, { placeholder: placholder })}
        />
      </div>
      {standalone ? (
        <RichTextInput
          {...Object.assign({}, fieldsData.description)}
          onChange={(v) => {
            // Clear out "empty" description.
            if (v === "<p><br></p>") v = ""
            fieldsData.description.onChange(v)
          }}
          errors={
            fieldsData.description.errorMessage
              ? [fieldsData.description.errorMessage]
              : null
          }
          hideCaution
        />
      ) : undefined}
      <div className="PathStep__FormControls">
        <Button onClick={onCancel} styleType="blank">
          Cancel
        </Button>
        <SubmitButton
          {...Object.assign({}, props, {
            styleType: "primary",
            type: "submit"
          })}
          disabled={!isValid}
        >
          {actionLabel}
        </SubmitButton>
      </div>
    </form>
  )
}

PathStepForm = ConnectForm(PathStepForm, fieldsData)
PathStepForm.displayName = "PathStepForm"

export default PathStepForm

function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null
    ? transform(value)
    : undefined
}
